import React from 'react';
import TableWrapper from './style';

const Tabular = props => (
  <TableWrapper
    {...props}
  />
);


export default Tabular;
